import React from "react";
import { ImageOff } from "lucide-react";
import landing from "@/content/landing";
import landingMedia from "@/content/landing-media";
import { Section } from "./HeroSection";

export default function PlatformShowcase() {
  const t = landing.platform;
  const screenshots = landingMedia.platformScreenshots || {};

  return (
    <Section id="platform" className="bg-white" data-testid="landing-platform">
      <div className="max-w-3xl">
        <h2 className="font-serif text-3xl leading-tight text-ag-ink sm:text-4xl lg:text-5xl">
          {t.headline}
        </h2>
        <p className="mt-5 font-serif text-lg italic text-slate-600 sm:text-xl">{t.intro}</p>
        <p className="mt-4 text-base leading-relaxed text-slate-700 sm:text-[17px]">{t.body}</p>
        <p className="mt-4 text-sm leading-relaxed text-slate-500">{t.closing}</p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-4 sm:mt-14 sm:grid-cols-2 lg:grid-cols-4">
        {t.screenshots.map((shot) => {
          const src = screenshots[shot.key];
          return (
            <figure
              key={shot.key}
              className="overflow-hidden rounded-2xl border border-slate-200/70 bg-ag-paper"
              data-testid={`landing-platform-shot-${shot.key}`}
            >
              <div className="relative flex items-center justify-center bg-slate-100" style={{ aspectRatio: "4 / 3" }}>
                {src ? (
                  <img
                    src={src}
                    alt={`Plattform-Vorschau: ${shot.label}`}
                    className="h-full w-full object-cover"
                    loading="lazy"
                  />
                ) : (
                  <div className="flex flex-col items-center gap-2 text-slate-400" aria-hidden="true">
                    <ImageOff className="h-8 w-8" strokeWidth={1.4} />
                    <span className="text-xs uppercase tracking-[0.2em]">Bild folgt</span>
                  </div>
                )}
              </div>
              <figcaption className="px-4 py-3 text-sm font-medium text-ag-ink">{shot.label}</figcaption>
            </figure>
          );
        })}
      </div>
    </Section>
  );
}
